import React, { useState } from 'react';
import classNames from 'classnames';
import MembershipOrderTbbContainer from '../../views/MembershipOrderTbb/MembershipOrderTbbContainer';
import ChevronDownIcon from '../../images/chevron-down.svg';
import UnlimitedLogoSVG from '../SvgComponents/UnlimitedLogo_svg';

import './CollapsibleOrderTbb.scss';

const CollapsibleOrderTbb = ({
  className = '',
  defaultExpanded = false,
  isConfirmationStep = false,
  onStepChange,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={classNames('CollapsibleOrderTbb', className)}>
      <div
        className={classNames(
          'CollapsibleOrderTbb__collapsed-view',
          { 'CollapsibleOrderTbb__collapsed-view--hidden': isExpanded },
        )}
      >
        <div className="CollapsibleOrderTbb__image-container">
          <button
            type="button"
            className="CollapsibleOrderTbb__expand-btn"
            onClick={toggleExpanded}
            aria-label="Expand"
          >
            <img src={ChevronDownIcon} alt="Expand" />
          </button>
          <UnlimitedLogoSVG width={257} height={56} />
        </div>
      </div>

      <div
        className={classNames(
          'CollapsibleOrderTbb__expanded-view',
          {
            'CollapsibleOrderTbb__expanded-view--hidden': !isExpanded,
            confirmation: isConfirmationStep,
          },
        )}
      >
        <button
          type="button"
          className="CollapsibleOrderTbb__collapse-btn"
          onClick={toggleExpanded}
          aria-label="Collapse"
        >
          <img src={ChevronDownIcon} alt="Collapse" />
        </button>

        <div className="CollapsibleOrderTbb__expanded-content">
          <MembershipOrderTbbContainer
            hideOrderCta={false}
            orderConfirmationShowCta
            productSelectionClassName="CollapsibleOrderTbb__step--product-selection"
            addressesContainerClassName="CollapsibleOrderTbb__step--addresses-container"
            orderConfirmationClassName="CollapsibleOrderTbb__step--order-confirmation"
            onStepChange={onStepChange}
          />
        </div>
      </div>
    </div>
  );
};

export default CollapsibleOrderTbb;
